import { InjectionToken as CoreAuthConfigProvider } from '@angular/core';
import { CoreAuthConfig } from '../interfaces';

export type providerType = CoreAuthConfig;
export const providerToken = new CoreAuthConfigProvider<CoreAuthConfig>(
  'CORE-AUTH-CONFIG'
);
